import {
  GET_LOCATIONS_SUCCESS,
  GET_RESOURCES_ERROR,
  GET_RESOURCES_REQUEST,
  GET_RESOURCES_SUCCESS,
  PUT_RESOURCES_ERROR,
  PUT_RESOURCES_REQUEST,
  PUT_RESOURCES_SUCCESS,
} from './constants';
import { Actions } from './actions';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,

  locations: [] as any,
  resource: [] as any,
};

type ResourcesState = typeof initialState;

export const ResourcesReducer = (state: ResourcesState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_LOCATIONS_SUCCESS: {
      return {
        ...state,
        error: null,
        locations: action.payload,
      };
    }
    case GET_RESOURCES_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        resource: action.payload,
      };
    }
    case GET_RESOURCES_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_RESOURCES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case PUT_RESOURCES_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case PUT_RESOURCES_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case PUT_RESOURCES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
